import type { TFunction } from 'i18next';
import { AddonKey } from 'app/modules/settings/modules/billing/types';

/**
 * Static presentation metadata for add-ons. The API only returns
 * `key/label/quantity/unitAmount/currency`; the FE injects the rest
 * (icon, accent, blurb, unit suffix) to preserve the card layout.
 *
 * Keep this in sync with the addon catalog server-side
 * (`app/Kontentino/src/Billing/*` addon keys).
 */
type AddonPresentation = {
  description: string;
  accent: 'blue' | 'purple' | 'orange';
  iconLabel: string;
  unitSuffix: string;
};

const ADDON_VISUALS: Record<
  AddonKey,
  Pick<AddonPresentation, 'accent' | 'iconLabel'>
> = {
  extraSeat: {
    accent: 'blue',
    iconLabel: '+1',
  },
  extraProfile: {
    accent: 'purple',
    iconLabel: '⚡',
  },
};

export const getAddonPresentation = (
  key: AddonKey,
  t: TFunction,
): AddonPresentation => ({
  ...ADDON_VISUALS[key],
  description: t(`billing.addonsCatalog.${key}.description`),
  unitSuffix: t(`billing.addonsCatalog.${key}.unitSuffix`),
});
